import { Injectable } from '@angular/core';
import { PrivacyPolicyType } from 'src/app/common/enums/privacy-policy-type';

@Injectable({
  providedIn: 'root',
})
export class PrivacyPolicyStateService {
  private privatePolicyReadedState: { [value in PrivacyPolicyType]: boolean } = {
    [PrivacyPolicyType.BOOKKER]: false,
    [PrivacyPolicyType.ORGANIZATION]: false,
  };

  constructor() {}

  public init(): void {
    for (const key in this.privatePolicyReadedState) {
      this.privatePolicyReadedState[key as PrivacyPolicyType] = false;
    }
  }

  public setPolicyReaded(type: PrivacyPolicyType): void {
    this.privatePolicyReadedState[type] = true;
  }

  public isPolicyReaded(type: PrivacyPolicyType): boolean {
    return this.privatePolicyReadedState[type];
  }
}
